import { IconDashboard, IconArticle, IconKey, IconGardenCart, IconUserScan, IconTag, IconVolume } from '@tabler/icons-react';

const icons = {
  IconDashboard,
  IconArticle,
  IconKey,
  IconGardenCart,
  IconUserScan,
  IconTag,
  IconVolume
};

const panel = {
  id: 'panel',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: '总览',
      type: 'item',
      url: '/panel/dashboard',
      icon: icons.IconDashboard,
      breadcrumbs: false
    },
    {
      id: 'token',
      title: 'API 密钥',
      type: 'item',
      url: '/panel/token',
      icon: icons.IconKey,
      breadcrumbs: false
    },
    {
      id: 'log',
      title: '请求日志',
      type: 'item',
      url: '/panel/log',
      icon: icons.IconArticle,
      breadcrumbs: false
    },
    {
      id: 'pricing',
      title: '模型广场',
      type: 'item',
      url: '/panel/pricing',
      icon: icons.IconTag,
      breadcrumbs: false
    },
    {
      id: 'voices',
      title: '系统音色',
      type: 'item',
      url: '/panel/voices',
      icon: icons.IconVolume,
      breadcrumbs: false
    },
    {
      id: 'topup',
      title: '账务中心',
      type: 'item',
      url: '/panel/topup',
      icon: icons.IconGardenCart,
      breadcrumbs: false
    },
    {
      id: 'profile',
      title: '账户设置',
      type: 'item',
      url: '/panel/profile',
      icon: icons.IconUserScan,
      breadcrumbs: false
    }
  ]
};

export default panel;
